import { Dropcursor } from '@tiptap/extensions'

export type { DropcursorOptions } from '@tiptap/extensions'
export { Dropcursor } from '@tiptap/extensions'

export default Dropcursor
